import React, { useRef, useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, Text, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import Canvas from '../../canvas'
import { useStoreStore } from '../../../stores/storeInfo'
import SignatureFormView from '../SignatureFormView'

const VtInformationOnline = ({ navigation, route }) => {
  const {
    values,
    userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    totalnoofvtallowances
  } = route.params
  const store = useStoreStore()
  const personalstore = usePersonalStore()
  const intializeStore = useInitializeStore()
  const { loading, postvtonline } = useFormsStore()
  const [signatureDataURL, setSignatureDataURL] = useState('')
  const [hasDrawn, setHasDrawn] = useState(false)


  const handlesubmit = async (signatureDataURL: any) => {
    const data = {
      entityId: personalstore?.personalData?.entityId,
      essUserKey: intializeStore?.initializeData?.userkey,
      essObKey: essUserOnBoardingKey,
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      completeOnline: true,
      maritalStatus: values?.maritalstatus,
      noOneClaim: values?.nooneclaim ? values?.nooneclaim : null,
      filingJointly: values?.filingjointly ? values?.filingjointly : null,
      noOfDependents: values?.noofdependents ? values?.noofdependents : null,
      headOfHousehold: values?.headofhousehold ? values?.headofhousehold : null,
      totalNoOfVtallowances: totalnoofvtallowances,
      additionalAmount: values?.additionalamount ? values?.additionalamount : null,
      exempt: values?.exempt,
      sign: signatureDataURL
    }
    const response: any = await postvtonline(data)
    if (response?.success === true) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'VT Witholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('VtInformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",
          })
        }
        onSubmit={handlesubmit}
      />

    </>
  )
}

export default VtInformationOnline
